import { createMuiTheme } from '@material-ui/core/styles';

import styles from './styles.module.scss';

export default createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: styles.black,
    },
    secondary: {
      main: styles.white,
    },
  },
  overrides: {
    MuiInputBase: {
      root: {
        height: 42,
        marginTop: 6,
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: '10.5px 14px',
      },
    },
    MuiInputLabel: {
      root: {
        color: styles.baseGray,
      },
      shrink: {
        marginTop: 6,
        zIndex: 1,
      },
    },
    MuiFormHelperText: {
      contained: {
        marginTop: 0,
        fontSize: 12,
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: '#fff',
        },
      },
    },
  },
  typography: {
    fontFamily: styles.fontFamily,
    fontSize: 15,
  },
});
